"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const vue_property_decorator_1 = require("vue-property-decorator");
let BtnFavorito = class BtnFavorito extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.favorito = this.value;
    }
    addFavorito() {
        this.loading = true;
        axios_1.default
            .get(`/api/inmueble/${this.inmuebleId}/favorito-add`)
            .then(respose => {
            this.favorito = true;
            this.loading = false;
            this.$bvToast.toast(`Se agrego el inmueble a tu lista de favoritos`, {
                title: `Agregar a Favoritos`,
                solid: true,
                variant: "success"
            });
        })
            .catch(error => {
            this.$bvToast.toast(error, {
                title: `Error`,
                variant: `danger`,
                solid: true
            });
        });
    }
    removeFavorito() {
        this.loading = true;
        axios_1.default
            .get(`/api/inmueble/${this.inmuebleId}/favorito-remove`)
            .then(respose => {
            this.favorito = false;
            this.loading = false;
            this.$bvToast.toast(`Se removio el inmueble a tu lista de favoritos`, {
                title: `Remover de Favoritos`,
                solid: true,
                variant: "success"
            });
        })
            .catch(error => {
            this.$bvToast.toast(error, {
                title: `Error`,
                variant: `danger`,
                solid: true
            });
        });
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], BtnFavorito.prototype, "inmuebleId", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], BtnFavorito.prototype, "value", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false, default: "link" }),
    __metadata("design:type", String)
], BtnFavorito.prototype, "variant", void 0);
BtnFavorito = __decorate([
    vue_property_decorator_1.Component({})
], BtnFavorito);
exports.default = BtnFavorito;
